/* React hooks */
import { useEffect } from "react";
/* Routing */
import { useParams } from "react-router-dom";
/* Contexts */
import useData from "../../../hooks/useData";
/* Components */
import FormActivities from "../../../forms/admin/FormActivities";
import Header from "../../../components/common/Header";
import {getActivityInfos, getActivityList} from "../../../api/admin/activityReq";
import useAuth from "../../../hooks/useAuth";


export default function ViewActivitiesInfos() {
    const { id } = useParams();
    const { activityInfos, setActivityInfos,
        activityList, setActivityList
    } = useData();
    const { auth } = useAuth();
    const token = auth.token;

    const apiActivityInfos = async () => {
        const response = getActivityInfos(token, id);
        setActivityInfos(response);
    }

    const apiActivityList = async () => {
        const response = await getActivityList(token);
        setActivityList(response);
    };

    useEffect(() => {
        apiActivityInfos();
    }, [ id ]);

    return (
        <main>
            <Header parent="Activités"
                    location={ (id !== 0)
                        ? "Modification d'une activité "
                        : "Ajout d'une activité " }
                    locationComp ={`${activityInfos && activityInfos?.name }`}
                    slug="/admin/activites"
            />
            <FormActivities apiActivities={apiActivityList} data={id !== 0 ? activityInfos : ""} legend="Informations sur une activité"/>
        </main>
    )
}